export default {
  dataTable: [],
  dataTables: {},
  dataPaginations: {},
  tableQueries: {}
}



// WEBPACK FOOTER //
// ./src/components/app/gsTable/store/state.js